export const shouldCartBeVisible = () => {
  return window.location.href.indexOf("summary") < 0 &&
  window.location.href.indexOf("finish") < 0 &&
  window.location.href.indexOf("beneficiaries") < 0;
};
